import { app } from '@/store';
import usePlanPermission from '@/modules/common/composable/usePlanPermission';
import { mutations } from '@modules/libraries/store/types';
export const handleAddToLibrary = async ($element: HTMLElement, type = 'block') => {
  const { checkValidSaveToLibrary } = usePlanPermission();
  const isValid = await checkValidSaveToLibrary();
  if (isValid) {
    app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type, target: $element });
  } else {
    app.$store.commit(`library/${mutations.UPDATE_SHOW_ADD_TO_LIBRARY_ON_BOARDING}`, {
      type,
      target: $element,
      visible: true,
    });
  }
};
